module.exports = __webpack_public_path__ + "img/invoice.a9fb8283.png";